import React, { Component, PropTypes } from 'react';
import AllNotifications from 'notifications/containers/all';
import { LoadingIndicator } from 'common/components/preloader';
import { Meta } from 'common/components/meta';
import { PAGINATION_PAGE_SIZE } from 'common/variables';
import Pager from 'common/containers/pager';
import { scrollToPageTop } from 'common/utils';

export default class NotificationsPage extends Component {
  constructor(props) {
    super(props);
    this.onPageChange = this.onPageChange.bind(this);
  }

  componentDidMount() {
    const { fetchNotifications, userId, currentPage } = this.props;
    const offset = PAGINATION_PAGE_SIZE * (currentPage - 1);
    if (userId) {
      fetchNotifications(userId, offset);
    }
  }

  onPageChange(page) {
    const { fetchNotifications, userId } = this.props;
    const offset = PAGINATION_PAGE_SIZE * (page - 1);
    if (userId) {
      fetchNotifications(userId, offset);
      scrollToPageTop();
    }
  }

  render() {
    const { isLoading, list, pageCount, currentPage } = this.props;


    if (isLoading || !list) {
      return <LoadingIndicator />;
    }

    return (<div id="content" className="l-content notifications-page">
      <Meta title="Notifications" />
      <div className="row">
        <div className="small-16 medium-12 column">
          <AllNotifications />
          {pageCount > 1 && <Pager
            pageCount={pageCount}
            currentPage={currentPage}
            onPageChange={this.onPageChange}
          />}
        </div>
      </div>
    </div>);
  }
}

NotificationsPage.propTypes = {
  userId: PropTypes.number.isRequired,
  fetchNotifications: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  list: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
};
